import { Template } from "./template.js";

const Left_menu = {
  props: {
    modems: Array,
    selectedModemLogs: Object,
  },
  components: {
    "ag-grid-vue": window.agGridVue.AgGridVue,
  },
  data() {
    return {
      perPage: globalConstants.linesPerPageLeftMenu,
      selectedModem: null,
      newComment: null,
      fields: [
        {
          field: "wire",
          headerName: "",
        },
        {
          field: "serial",
          headerName: this.$t("modems.sN"),
          sortable: true,
          filter: true,
          flex: 1,
        },
      ],
    };
  },
  updated() {
    this.fields[1].label = this.$t("modems.sN");
  },
  computed: {
    transformedModemRows() {
      return this.modems.map((m) => ({
        ...m,
        wire: m.too_old ? "⏰" : "",
        serial:
          m.serial.length > 35
            ? `${m.serial.slice(0, 35)}...`
            : m.serial.slice(0, 35),
      }));
    },
    modemInfoFields() {
      if (this.selectedModem)
        return [
          { label: "IMEI", value: this.selectedModemLogs.IMEI },
          { label: "IMSI", value: this.selectedModemLogs.IMSI },
          { label: "ICCID", value: this.selectedModemLogs.ICCID },
          { label: "NUM", value: this.selectedModemLogs.num },
          { label: "UTC", value: this.selectedModemLogs.UTC },
          {
            label: this.$t("modems.activity"),
            value: `${this.selectedModem.too_old && "⏰"} ${
              this.selectedModem.measure_time
            }`,
          },
          { label: this.$t("modems.modem"), value: this.selectedModem.serial },
        ];
    },
  },
  methods: {
    onFirstDataRendered() {
      this.gridColumnApi.autoSizeColumn("wire");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onModemChanged() {
      const selectedRows = this.gridApi.getSelectedRows();
      this.selectedModem = selectedRows[0];
      this.newComment = selectedRows[0].comment;
      this.$emit(
        "line-click",
        selectedRows[0].serial.includes("...")
          ? this.modems.find((m) => m.serial.includes(selectedRows[0].serial))
          : selectedRows[0].serial
      );
    },
    updateComment() {
      //сохраняем комментарий
      this.$API(
        "static_data",
        "updateModemComment",
        {
          serial: this.selectedModem.serial,
          comment: this.newComment,
        },
        () => {
          this.selectedModem.comment = this.newComment; //если запрос прошел, записываем переменную, чтобы пропала кнопка сохранения
        },
        function () {}
      );
    },
  },
  template: Template,
};

export { Left_menu };



// WEBPACK FOOTER //
// ./src/app/js/components/onewire/left_menu/component.js